import { useEffect, useMemo, useState } from 'react';

import { PlayerAPI } from '@vimeo/embed-player';

export const usePlayer = () => {
  const [player, setPlayer] = useState<PlayerAPI | null>(null);
  const [isInitialized, setInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (!player) return;

    player.ready().finally(() => setInitialized(true));
  }, [player]);

  return useMemo(
    () => ({
      player,
      onPlayerInitialized: setPlayer,
      isInitialized,
    }),
    [player, isInitialized],
  );
};
